export const it = {
  // Navigation
  nav: {
    home: "Home",
    gallery: "Galleria",
    landscapes: "Paesaggi",
    portraits: "Ritratti",
    abstract: "Astratto",
    about: "Chi Sono",
    contact: "Contatti",
    shop: "Negozio",
    shopAll: "Shop all",
    print: "Print",
    original: "Original",
    cart: "Carrello",
    admin: "Admin",
    myOrders: "I Miei Ordini",
    login: "Accedi",
    logout: "Esci",
    account: "Account",
  },

  // Home page
  home: {
    heroTitle: "Arte che racconta storie",
    heroSubtitle: "Arte per spazi vissuti.",
    heroCta: "Shop all",
    categoriesTitle: "Shop",
    categoriesSubtitle: "Esplora per categoria",
    featuredTitle: "Opere in Evidenza",
    featuredSubtitle: "Selezionate per te",
    viewAll: "Vedi Tutte",
    aboutTitle: "L'Artista",
    aboutText: "Ogni pennellata racconta una storia. Scopri il mondo di Dalila Di Maria attraverso le sue opere originali.",
    aboutCta: "Scopri di più",
    mailingListTitle: "Iscriviti alla mailing list",
    mailingListText: "Scopri per prima le nuove collezioni",
    mailingListSubmit: "Iscriviti alla mailing list",
    mailingListSuccess: "Grazie, sei iscritta alla mailing list.",
  },

  // Categories
  categories: {
    print: "Print",
    printDesc: "Una selezione di stampe Fine Art tratte dai miei dipinti originali, disponibili in diverse dimensioni.",
    original: "Original",
    originalDesc: "Opere uniche dipinte a mano",
    landscapes: "Paesaggi",
    landscapesDesc: "La bellezza della natura catturata su tela",
    portraits: "Ritratti",
    portraitsDesc: "L'anima delle persone attraverso il colore",
    abstract: "Astratto",
    abstractDesc: "Emozioni e forme oltre la realtà",
  },

  // Product/Artwork
  artwork: {
    price: "Prezzo",
    technique: "Tecnica",
    dimensions: "Dimensioni",
    year: "Anno",
    category: "Categoria",
    available: "Disponibile",
    sold: "Venduto",
    reserved: "Riservato",
    reservationNotice: "Quest'opera è momentaneamente riservata a un altro potenziale acquirente durante il pagamento. Verrà liberata automaticamente entro 30 minuti se l'acquisto non viene completato.",
    addToCart: "Acquista",
    buyNow: "Acquista Ora",
    inquire: "Richiedi Informazioni",
    relatedWorks: "Opere Correlate",
    details: "Dettagli",
    shipping: "Spedizione",
    printInfo: "Stampe d'arte di alta qualità realizzate su pregiata carta 100% cotone, per mantenere i colori e i dettagli dei miei dipinti originali splendidi nel tempo.",
    shippingInfo: "I costi di spedizione sono inclusi nel prezzo.",
    printShippingInfo: "Per le print la spedizione in Italia è inclusa nel prezzo. Per gli ordini internazionali viene applicato un supplemento, calcolato al checkout.",
    trackingInfo: "Un link di tracciamento internazionale verrà inviato quando l'opera sarà spedita.",
  },

  // Cart & Checkout
  cart: {
    title: "Il Tuo Carrello",
    empty: "Il carrello è vuoto",
    continueShopping: "Continua a Esplorare",
    subtotal: "Subtotale",
    shipping: "Spedizione",
    total: "Totale",
    checkout: "Procedi al Pagamento",
    remove: "Rimuovi",
  },

  // Checkout
  checkout: {
    title: "Pagamento",
    customerInfo: "Informazioni di Contatto",
    name: "Nome Completo",
    email: "Email",
    confirmEmail: "Conferma email",
    guestEmailHelp: "Conferma la tua email per ricevere la conferma dell'ordine.",
    emailsDoNotMatch: "Gli indirizzi email non coincidono.",
    phone: "Telefono",
    shippingAddress: "Indirizzo di Spedizione",
    address: "Indirizzo",
    city: "Città",
    postalCode: "CAP",
    postcode: "Codice postale",
    zipCode: "ZIP code",
    state: "Stato",
    province: "Provincia",
    stateTerritory: "Stato / Territorio",
    country: "Paese",
    notes: "Note (opzionale)",
    pay: "Paga Ora",
    processing: "Elaborazione...",
    secure: "Pagamento sicuro con Stripe",
    shippingIncluded: "Inclusa",
    shippingCalculated: "Calcolata dopo la scelta del paese",
    shippingCalculating: "Calcolo in corso…",
  },

  // Contact
  contact: {
    title: "Contattami",
    subtitle: "Hai domande su un'opera o vuoi commissionare un lavoro personalizzato?",
    name: "Nome",
    email: "Email",
    subject: "Oggetto",
    message: "Messaggio",
    tiktok: "Parlami su TikTok",
    send: "Invia Messaggio",
    success: "Messaggio inviato con successo! Ti risponderò presto.",
    error: "Errore nell'invio del messaggio. Riprova.",
  },

  // About
  about: {
    title: "Chi Sono",
    subtitle: "Mi chiamo Dalila Di Maria.",
    intro: "Dipingo mondi silenziosi, plasmati dalla natura, dalla memoria e dalle storie che rimangono con noi.",
    invitation: "Il mio lavoro è un invito a fermarsi e a notare la piccola bellezza della vita quotidiana.",
    quote: "La pittura è più forte di me, mi fa fare quello che vuole.",
    quoteAuthor: "Pablo Picasso",
    artworkAlt: "Dipinto floreale con uccelli",
    revealColor: "Mostra il dipinto a colori",
    studioTitle: "Il Mio Studio",
    processTitle: "Il Mio Processo Creativo",
    commissionsTitle: "Commissioni",
    commissionsText: "Accetto commissioni per opere personalizzate. Contattami per discutere la tua idea.",
    commissionsCta: "Richiedi una Commissione",
  },

  // Auth
  auth: {
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    confirmPassword: "Conferma Password",
    forgotPassword: "Password dimenticata?",
    loginWithGoogle: "Accedi con Google",
    loginWithEmail: "Accesso con password",
    noAccount: "Non hai un account?",
    hasAccount: "Hai già un account?",
    createAccount: "Crea Account",
    createPassword: "Crea una password",
    collectorSignIn: "Accesso collezionista",
    createCollectorAccount: "Crea un account collezionista",
    accountDescription: "Usa il tuo account per salvare i dati di pagamento e gestire gli ordini dello studio Dalila.",
    magicLinkTitle: "Accedi con la tua email",
    magicLinkDescription: "Ti invieremo un link sicuro. Se è la prima volta, creeremo il tuo account automaticamente.",
    sendMagicLink: "Invia link di accesso",
    magicLinkSent: "Controlla la tua email per il link di accesso.",
    checkInbox: "Se l'indirizzo può ricevere email, troverai un link di accesso nella tua casella. Il link scade dopo 15 minuti.",
    passwordLoginDescription: "Accedi al tuo account con email e password.",
    passwordRegisterDescription: "Crea un account con una password sicura per gestire i tuoi ordini.",
    passwordHint: "Usa almeno 5 caratteri.",
    continueWithGoogle: "Continua con Google",
    orContinueWith: "oppure continua con",
    googleNotConfigured: "L'accesso con Google non è ancora disponibile.",
    googleCancelled: "L'accesso con Google è stato annullato.",
    googleFailed: "Non è stato possibile completare l'accesso con Google. Riprova.",
    passwordsDoNotMatch: "Le password non coincidono.",
    legacyPasswordHelp: "Hai già un account creato con il vecchio accesso via email? Inserisci qui sopra la tua email e usa il link una sola volta per impostare la password nella tua area account.",
    legacyPasswordAction: "Invia un link di accesso temporaneo",
    legacyPasswordEmailRequired: "Inserisci prima il tuo indirizzo email.",
  },

  // Account
  account: {
    title: "Il Mio Account",
    subtitle: "Gestisci il tuo profilo e visualizza i tuoi ordini dallo studio Dalila.",
    welcome: "Benvenuto",
    roleUser: "Collezionista",
    roleAdmin: "Amministratore",
    profile: "Profilo",
    name: "Nome",
    email: "Email",
    orders: "I Miei Ordini",
    ordersEmpty: "Non hai ancora ordini.",
    orderNumber: "Ordine n.",
    adminPanel: "Pannello Admin",
    logout: "Esci",
    passwordTitle: "Password",
    passwordDescription: "Imposta una password per accedere senza usare un link via email.",
    setPassword: "Salva password",
    passwordSaved: "Password salvata.",
  },

  orderStatus: {
    pending: "In attesa",
    paid: "Pagato",
    processing: "In preparazione",
    shipped: "Spedito",
    delivered: "Consegnato",
    cancelled: "Annullato",
    refunded: "Rimborsato",
  },

  // Footer
  footer: {
    rights: "Tutti i diritti riservati",
    privacy: "Privacy",
    terms: "Termini e Condizioni",
    followMe: "Seguimi",
    newsletter: "Newsletter",
    newsletterText: "Iscriviti per ricevere aggiornamenti sulle nuove opere",
    subscribe: "Iscriviti",
    emailPlaceholder: "La tua email",
    shippingPolicy: "Spedizioni",
    returnPolicy: "Resi",
  },

  // Common
  common: {
    loading: "Caricamento...",
    error: "Si è verificato un errore",
    retry: "Riprova",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    close: "Chiudi",
    search: "Cerca",
    filter: "Filtra",
    sortBy: "Ordina per",
    noResults: "Nessun risultato",
    viewMore: "Vedi di più",
    backToHome: "Torna alla Home",
  },

  // Order confirmation
  orderConfirmation: {
    title: "Ordine Confermato!",
    subtitle: "Grazie per il tuo acquisto",
    orderNumber: "Numero Ordine",
    emailSent: "Ti abbiamo inviato una conferma via email.",
    continueShopping: "Continua a Esplorare",
    processingTitle: "Pagamento ricevuto",
    processingSubtitle: "Stiamo verificando il pagamento in modo sicuro. Questa pagina si aggiornerà automaticamente.",
    processingEmail: "L'email di conferma verrà inviata solo dopo la convalida del pagamento.",
    processingError: "Non riusciamo ancora a verificare lo stato. Se il pagamento viene confermato, riceverai l'email dell'ordine.",
    cancelledTitle: "Pagamento annullato",
    cancelledSubtitle: "Non è stato effettuato alcun addebito e non è stato creato alcun ordine. L'opera tornerà disponibile alla scadenza della prenotazione temporanea.",
    backToGallery: "Torna alla galleria",
  },
} as const;

export type Translations = {
  [Section in keyof typeof it]: {
    [Key in keyof (typeof it)[Section]]: string;
  };
};
